/**
 * Arabic for changing the equipment register — the add, edit, transfer,
 * retire and import forms, the field names and the change log.
 * Proposed; pending native aviation review. The field labels keep the three
 * permits worded apart, as `equipment.ts` explains.
 */
const ar: Record<string, string> = {
  Tag: "الرمز",
  Make: "الصانع",
  "Owned by": "الملكية",
  "Used by department": "الإدارة المستخدِمة",
  "Condition note": "ملاحظة الحالة",
  "Driver's airside driving permit": "رخصة السائق للقيادة في الجانب الجوي",
  "Driving permit expiry": "انتهاء رخصة القيادة في الجانب الجوي",
  "Vehicle license expiry": "انتهاء رخصة سير المركبة",
  "Insurance expiry": "انتهاء التأمين",
  "Airside vehicle permit": "تصريح دخول الجانب الجوي",
  "Airside permit expiry": "انتهاء تصريح الجانب الجوي",
  "Last safety inspection": "آخر فحص سلامة",
  "Next safety inspection due": "موعد فحص السلامة التالي",
  Added: "أُضيف",
  Edited: "عُدِّل",
  Transferred: "نُقل",
  Retired: "مُستبعَد من الخدمة",
  Reinstated: "أُعيد إلى الخدمة",
  Imported: "استُورد",
  "The airport": "المطار",
  "A stakeholder": "جهة معنية",
  "That tag is already on the register. A tag is never reused, retired items included.":
    "هذا الرمز موجود في السجل. لا يُعاد استخدام أي رمز، بما في ذلك رموز العناصر المستبعدة.",
  "A tag is needed: it is how work orders and notes find the item.":
    "الرمز مطلوب: به تعثر أوامر العمل والملاحظات على العنصر.",
  "A name is needed.": "الاسم مطلوب.",
  "Choose a type.": "اختر النوع.",
  "Choose a condition.": "اختر الحالة.",
  "Say whether the airport or a stakeholder owns it.": "حدّد ما إذا كان المالك المطار أم جهة معنية.",
  "Name the owner.": "اذكر اسم المالك.",
  "A date is written YYYY-MM-DD.": "يُكتب التاريخ بصيغة YYYY-MM-DD.",
  "A year of manufacture, four digits.": "سنة الصنع، أربعة أرقام.",
  "Hours run is a number, zero or more.": "ساعات التشغيل رقم، صفر أو أكثر.",
  "A driving permit needs the driver's name.": "رخصة القيادة تحتاج إلى اسم السائق.",
  "This cell cannot be read.": "تعذّرت قراءة هذه الخلية.",
  "No tag on this row.": "لا رمز في هذا الصف.",
  "This tag appears twice in the file.": "يتكرر هذا الرمز مرتين في الملف.",
  "This item is retired. Reinstate it first.": "هذا العنصر مستبعد من الخدمة. أعِده إلى الخدمة أولاً.",
  "The file needs a heading row and at least one item.": "يحتاج الملف إلى صف عناوين وعنصر واحد على الأقل.",
  "No tag column: every row needs the item's tag.": "لا يوجد عمود للرمز: كل صف يحتاج إلى رمز العنصر.",
  new: "جديد",
  update: "تحديث",
  "no change": "بلا تغيير",
  "cannot import": "لا يمكن استيراده",
  "What it is": "ما هو",
  "Who owns it": "من يملكه",
  "Its condition and where it is": "حالته وموقعه",
  "Who drives it": "من يقوده",
  "Licence, insurance, permit and inspection": "الرخصة والتأمين والتصريح والفحص",
  "Where it came from (optional)": "مصدره (اختياري)",
  "Reason for the change (optional)": "سبب التغيير (اختياري)",
  "Takes effect": "يسري من",
  "Reason for the transfer": "سبب النقل",
  "Why it is coming back": "سبب إعادته",
  "Why it is being retired": "سبب استبعاده",
  "Or paste the rows": "أو الصق الصفوف",
  "Where these rows came from": "مصدر هذه الصفوف",
  "Change log": "سجل التغييرات",
  "every addition, edit, transfer, retirement and import, with who made it, when, and each value before and after; nothing here can be edited or removed":
    "كل إضافة وتعديل ونقل واستبعاد واستيراد، مع من قام به ومتى، وكل قيمة قبل التغيير وبعده؛ لا يمكن تعديل أي شيء هنا أو حذفه",
  "off the working register, kept with their history; a retired tag is never reused":
    "خارج السجل العامل، محفوظة مع سجلها؛ لا يُعاد استخدام رمز مستبعد",
  "every change to this item, who made it and when, each value before and after; append-only":
    "كل تغيير على هذا العنصر، ومن قام به ومتى، وكل قيمة قبل التغيير وبعده؛ إضافة فقط",
  "Add an item to the register": "إضافة عنصر إلى السجل",
  "Edit {tag}": "تعديل {tag}",
  "The tag cannot be changed: work orders and notes find the item by it. The owner and the department change by Transfer, which records why.":
    "لا يمكن تغيير الرمز: به تعثر أوامر العمل والملاحظات على العنصر. يتغيّر المالك والإدارة عبر النقل، الذي يسجّل السبب.",
  "A blank date is saved as not recorded, and the register shows it as such — never as met.":
    "يُحفظ التاريخ الفارغ على أنه غير مسجّل، ويعرضه السجل كذلك — وليس مستوفى أبداً.",
  "Add to the register": "أضف إلى السجل",
  "Save the changes": "احفظ التغييرات",
  "A transfer needs a reason.": "النقل يحتاج إلى سبب.",
  "Nothing has changed: the owner, department and location are as they were.":
    "لم يتغير شيء: المالك والإدارة والموقع كما كانت.",
  "Transfer {tag}": "نقل {tag}",
  "Now: {owner} · {dept}": "حالياً: {owner} · {dept}",
  "no department recorded": "لا إدارة مسجّلة",
  "Record the transfer": "سجّل النقل",
  "A reason is needed.": "السبب مطلوب.",
  "Reinstate {tag}": "إعادة {tag} إلى الخدمة",
  "Retire {tag}": "استبعاد {tag} من الخدمة",
  "It returns to the working register with everything it had.": "يعود إلى السجل العامل بكل ما كان لديه.",
  "It leaves the working register but is not deleted: its history, its notes and its tag are kept, and the tag is never given to another item.":
    "يخرج من السجل العامل لكنه لا يُحذف: يُحفظ سجله وملاحظاته ورمزه، ولا يُعطى الرمز لعنصر آخر أبداً.",
  Reinstate: "أعِد إلى الخدمة",
  Retire: "استبعد من الخدمة",
  "An Excel workbook cannot be read directly. In Excel choose Save As › CSV, or copy the rows and paste them below.":
    "لا يمكن قراءة مصنف Excel مباشرة. في Excel اختر حفظ باسم › CSV، أو انسخ الصفوف والصقها أدناه.",
  "Rows pasted on {date}": "صفوف لُصقت في {date}",
  "Imported rows": "صفوف مستوردة",
  "Import the register": "استيراد السجل",
  "Choose a CSV file, or copy the rows from Excel and paste them here. The first row names the columns. A row whose tag is already on the register updates that item; a new tag adds one. A blank cell leaves what is recorded as it is — an import never erases a date. Dates are YYYY-MM-DD or day/month/year.":
    "اختر ملف CSV، أو انسخ الصفوف من Excel والصقها هنا. الصف الأول يسمّي الأعمدة. الصف الذي رمزه موجود في السجل يحدّث ذلك العنصر؛ والرمز الجديد يضيف عنصراً. الخلية الفارغة تترك المسجَّل كما هو — الاستيراد لا يمحو تاريخاً أبداً. التواريخ بصيغة YYYY-MM-DD أو يوم/شهر/سنة.",
  "Columns:": "الأعمدة:",
  "Download the template": "نزّل النموذج",
  "Choose a file": "اختر ملفاً",
  "Check the rows": "افحص الصفوف",
  "{new} new, {update} to update, {same} unchanged, {error} that cannot be imported.":
    "{new} جديد، و{update} للتحديث، و{same} بلا تغيير، و{error} لا يمكن استيراده.",
  "Columns not recognized, and ignored: {cols}": "أعمدة غير معروفة، تم تجاهلها: {cols}",
  "line {n}": "السطر {n}",
  "No change has been made since the register was first entered.": "لم يُجرَ أي تغيير منذ إدخال السجل أول مرة.",
  "takes effect {date}": "يسري من {date}",
  "Reason: {why}": "السبب: {why}",
  "Show the latest only": "اعرض الأحدث فقط",
  "on {date} by {who}: {why}": "في {date} بواسطة {who}: {why}",
  "Add an item": "أضف عنصراً",
  "Import from Excel or CSV": "استيراد من Excel أو CSV",
  "{n} thing to correct before saving.|{n} things to correct before saving.":
    "لا شيء للتصحيح|أمر واحد للتصحيح قبل الحفظ.|أمران للتصحيح قبل الحفظ.|{n} أمور للتصحيح قبل الحفظ.|{n} أمراً للتصحيح قبل الحفظ.|{n} أمر للتصحيح قبل الحفظ.",
  "{n} item imported. Each change is in the change log.|{n} items imported. Each change is in the change log.":
    "لم يُستورد شيء.|استُورد عنصر واحد. كل تغيير في سجل التغييرات.|استُورد عنصران. كل تغيير في سجل التغييرات.|استُوردت {n} عناصر. كل تغيير في سجل التغييرات.|استُورد {n} عنصراً. كل تغيير في سجل التغييرات.|استُورد {n} عنصر. كل تغيير في سجل التغييرات.",
  "{n} field|{n} fields": "لا حقول|حقل واحد|حقلان|{n} حقول|{n} حقلاً|{n} حقل",
  "Import {n} item|Import {n} items":
    "لا شيء للاستيراد|استورد عنصراً واحداً|استورد عنصرين|استورد {n} عناصر|استورد {n} عنصراً|استورد {n} عنصر",
  "{n} field recorded|{n} fields recorded":
    "لا حقول مسجّلة|حقل واحد مسجّل|حقلان مسجّلان|{n} حقول مسجّلة|{n} حقلاً مسجّلاً|{n} حقل مسجّل",
  "Show all {n} changes|Show all {n} changes":
    "لا تغييرات|اعرض التغيير الوحيد|اعرض التغييرين|اعرض {n} تغييرات|اعرض {n} تغييراً|اعرض {n} تغيير",
};
export default ar;
